import { render, staticRenderFns } from "./szsgmzyjsxy.vue?vue&type=template&id=74a2007a&scoped=true&"
import script from "./szsgmzyjsxy.vue?vue&type=script&lang=js&"
export * from "./szsgmzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./szsgmzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./szsgmzyjsxy.vue?vue&type=style&index=1&id=74a2007a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2007a",
  null
  
)

export default component.exports